import { render } from "./PackagePlans.vue?vue&type=template&id=0698fc13&scoped=true"
import script from "./PackagePlans.vue?vue&type=script&lang=js"
export * from "./PackagePlans.vue?vue&type=script&lang=js"

import "./PackagePlans.vue?vue&type=style&index=0&id=0698fc13&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0698fc13"]])

export default __exports__